import ng from 'angular';

export class FluxoAprovacoesConfirmModalController implements ng.IController {

    static $inject = [
        'NewToaster',
        '$uibModalInstance'
    ];

    constructor(
        public NewToaster: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
    ) {
    }

    public confirmar(): void {
        this.$uibModalInstance.close();
    }
}
